export default __webpack_public_path__ + "assets/json/84fcb878660886e5c2d088e610f17d26.json";